import { useQuery } from '@tanstack/react-query'
import { useCogfy } from './use-cogfy'

export function useWorkspaceTasksQuotaHistory (
  workspace: string
) {
  const cogfy = useCogfy()

  const getWorkspaceTasksQuotaHistory = useQuery({
    queryKey: ['getWorkspaceTasksQuotaHistory', workspace],
    queryFn: ({ signal }) => cogfy.getWorkspaceTasksQuotaHistory({ signal })
  })

  return getWorkspaceTasksQuotaHistory
}
